import { render, staticRenderFns } from "./svg-info.vue?vue&type=template&id=8c3d6bc2&"
import script from "./svg-info.vue?vue&type=script&lang=js&"
export * from "./svg-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports